import moment from 'moment';
import { getGenresReqParams } from '@intelligence/components/GenreSelectMiddleware/Supports/utils';
import { PER_TYPES, REVENUE_TYPES, GENRE_TYPES } from '../constants';
import type { IDateValue, IMomentDateValue } from '@/pages/intelligence/types/common';
import type { IPerType, IRevenueType, IFilter } from '../types';

export function getMomentDateValue(dateValue: IDateValue): IMomentDateValue {
  if (!Array.isArray(dateValue)) return [];
  const result: IMomentDateValue = [];
  for (const item of dateValue) {
    const mItem = moment(item);
    if (mItem.isValid()) {
      result.push(mItem);
    }
  }
  return result.length === 2 ? result : [];
}

export function buildGenresReqParams(option: { perType: IPerType; filter: any }): any[] {
  const { perType, filter } = option || {};
  if (perType === PER_TYPES.MARKET) return [];
  let result: any[] = [];
  if (filter?.genreType === GENRE_TYPES.MAIN) {
    result = filter?.genres?.map((item: any) => ({ value: item, children: [] }));
  } else {
    const genreData = getGenresReqParams(
      {},
      { source: 'iegg', mainGenres: filter?.mainGenres, subGenres: filter?.subGenres },
    );
    result = genreData?.iegg_genre_req?.map((item: any) => ({
      value: item?.value,
      children: item?.children || [],
    }));
  }
  return Array.isArray(result) ? result : [];
}

// sortKey处理，后端只需要1st或者1st_ratio去判断是按值排序还是环比排序
export function getSortKey(sortKey: string) {
  if (typeof sortKey !== 'string') return '';
  const len = sortKey?.length;
  const sortNumber = sortKey?.substring(0, sortKey?.indexOf(' '));
  const sortRatio = sortKey?.substring(len - 1);
  return `${sortNumber}${sortRatio === '1' ? '_ratio' : ''}`;
}

/**
 * PC、console、total页面 根据勾选的年份，取最小年份、最大年份 作为开始、结束时间点
 */
export function getDateRangeByYears(option: { revenueType: IRevenueType; filter: IFilter }): IDateValue {
  const { revenueType, filter } = option || {};
  if (revenueType === REVENUE_TYPES.MOBILE) return filter?.dateValue || [];
  const years = filter?.years;
  if (!Array.isArray(years)) return [];
  const numYears = years.map((item) => Number.parseInt(item, 10));
  let minYear = Math.min.apply(null, numYears);
  let maxYear = Math.max.apply(null, numYears);
  minYear = minYear || maxYear;
  maxYear = maxYear || minYear;
  return [`${minYear}-01-01`, `${maxYear}-12-01`];
}

export const MAX_DIFF_YEARS = 5;
export function checkDateRangeDiff(
  startDate: moment.Moment | string,
  endDate: moment.Moment | string,
  diff = MAX_DIFF_YEARS,
  diffUnit = 'years',
): boolean {
  const startDateTmp = moment.isMoment(startDate) ? startDate : moment(startDate);
  const endDateTmp = moment.isMoment(endDate) ? endDate : moment(endDate);
  // @ts-ignore
  return endDateTmp.diff(startDateTmp, diffUnit) <= diff;
}

export function getDefaultYears() {
  const date = new Date();
  const year = date.getFullYear();
  return [year - 2, year - 1].map((item) => item?.toString(10));
}

// REMARK: 合并代码后，可以替换为src/pages/intelligence/utils/commonUtils.ts的同名方法
type ITranslater = (payload: { id: string }, params?: { [key: string]: any }) => string;
export const addFormatMessageSafelyHandler =
  (translater: ITranslater): ITranslater =>
  (payload, params) => {
    let result = '';
    try {
      result = translater(payload, params);
    } catch (exception) {
      console.warn(exception);
      result = payload?.id;
    }
    return result ?? '';
  };

export const isSameArrayValue = (arr1: string[], arr2: string[]): boolean => {
  if (arr1?.length !== arr2?.length) return false;
  return arr1?.every((item) => arr2?.includes(item));
};
